import React, { useEffect, useState } from 'react';
import styles from './slider.module.css';
import {ArrowRight} from '../../../icons/components/Slider';
import {Close} from '../../../icons/components/Slider';

const Slider = ({
  imageUrls = [],
  arrowLeft = false,
  arrowRight = false,
  dots = false,
  quantityPerItem = 1,
  previewPrev = false,
  previewNext = false,
  auto = 0,
  showIndex = 0,
  isNota = false,
  isOpen,
  currentSlide,
  onClose = () => { }
}) => {
  const [itemActual, setitemActual] = useState(currentSlide);
  const [touchPosition, setTouchPosition] = useState(null);

  const listSlider = [];
  for (let index = 0; index < imageUrls.length; index += quantityPerItem) {
    const itemsConcat = imageUrls.slice(index, index + quantityPerItem);
    listSlider.push(itemsConcat);
  }
  const itemLength = listSlider?.length;

  useEffect(() => {
    setitemActual(currentSlide);
  }, [currentSlide]);

  useEffect(() => {
    if (parseInt(auto) > 0) {
      const intervalId = setInterval(() => {
        next();
      }, parseInt(auto) * 1000);

      return () => clearInterval(intervalId);
    }
  }, []);

  useEffect(() => {
    setitemActual(showIndex);
  }, [showIndex]);

  useEffect(() => {
    typeof window !== 'undefined' &&
            window.addEventListener('keyup', (event) => {
              if (event.keyCode === 37) {
                prev();
              }
              if (event.keyCode === 39) {
                next();
              }
            });
  }, []);

  if (!Array.isArray(imageUrls) || itemLength === 0) return <></>;

  const handleClose = () => {
    onClose();
  };

  const next = () => {
    setitemActual((itemActual) =>
      itemActual === itemLength - 1 ? 0 : itemActual + 1
    );
  };

  const prev = () => {
    setitemActual((itemActual) =>
      itemActual === 0 ? itemLength - 1 : itemActual - 1
    );
  };

  const dotsClick = (index) => {
    setitemActual(index);
  };

  const handleTouchStart = (e) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = (e) => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 10) {
      next();
    }

    if (diff < -10) {
      prev();
    }

    setTouchPosition(null);
  };

  if (!isOpen) {
    return null;
  }

  const renderListSlider = listSlider.map((item, index) => {
    const currentItem = item[0];
    return (
      <li
        key={'slide' + index}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        className={
          itemActual === index
            ? `${styles.slideActive} ${styles.slideItem}`
            : styles.slideItem
        }
      >
        {itemActual === index && (
          <>
            <img src={currentItem.url} alt={`slide${index}`} />
            <p className={styles.epigraph}>{currentItem.epigraphe} <span className={styles.desktopOnly}>Imagen: {index + 1}/{itemLength}</span></p>
          </>
        )}
      </li>
    );
  });

  return (
    <div className={styles.container}>
      <button onClick={handleClose} className={styles.closeButton}>
        <Close />
      </button>
      <ul className={styles.slideContainer}>
        {previewPrev && (
          <li className={styles.slidePreviewPrev}>
            <img
              src={
                listSlider[itemActual - 1 >= 0
                  ? itemActual - 1
                  : itemLength - 1][0]
              }
              alt={'preview-prev'}
            />
          </li>
        )}
        {renderListSlider}
        {previewNext && (
          <li className={styles.slidePreviewNext}>
            <img
              src={
                listSlider[itemActual + 1 === itemLength
                  ? 0
                  : itemActual + 1][0]
              }
              alt={'preview-next'}
            />
          </li>
        )}
        {itemLength > 1 && (
          <li className="slide-group-control">
            {arrowLeft && (
              <div
                className={`${styles.arrow} ${styles.slideArrowLeft}`}
                onClick={() => (isNota ? next() : prev())}
              >
                <ArrowRight />
              </div>
            )}
            {dots &&
                            [...Array(itemLength)].map((_, i) => (
                              <div
                                className="slide-dots"
                                key={`slideDots${i}`}
                                onClick={() => dotsClick(i)}
                              >
                                {dots}
                              </div>
                            ))}
            {arrowRight && (
              <div
                className={`${styles.arrow} ${styles.slideArrowRight}`}
                onClick={() => (isNota ? prev() : next())}
              >
                <ArrowRight />
              </div>
            )}
          </li>
        )}
      </ul>
    </div>
  );
};

export default Slider;
